/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyCurrency
 */
export interface WriteOnlyCurrency {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyCurrency
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyCurrency
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyCurrency
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyCurrency
     */
    minorUnit?: number | null;
}

export function WriteOnlyCurrencyFromJSON(json: any): WriteOnlyCurrency {
    return WriteOnlyCurrencyFromJSONTyped(json, false);
}

export function WriteOnlyCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyCurrency {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'code': json['code'],
        'number': json['number'],
        'minorUnit': !exists(json, 'minor_unit') ? undefined : json['minor_unit'],
    };
}

export function WriteOnlyCurrencyToJSON(value?: WriteOnlyCurrency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'code': value.code,
        'number': value.number,
        'minor_unit': value.minorUnit,
    };
}


